import {FormikHelpers} from 'formik';
import {notify} from '@gemcook/notification';

import api from '@api';

export const submit = async (
  values: any,
  formikHelpers: FormikHelpers<any>,
  notification: NotificationsStore['detail'],
  me: MeStore,
  handleCloseModal: (isModal: boolean) => any,
  params: {id: string},
  setIsFailedSendModal: (isModal: boolean) => any,
  isFailed?: boolean
) => {
  let originalNotificationId: string[];
  try {
    if (params.id) {
      // 災害通知詳細の場合
      originalNotificationId = [params.id];
    } else {
      // ダッシュボードの場合
      originalNotificationId = notification.notificationIds;
    }
    await api.notifications.create({
      teamId: me.teamId,
      // 震度0固定
      isEmailSending: values.isEmailSending,
      isSMSSending: values.isSMSSending,
      isConnectSending: values.isConnectSending,
      isManual: true,
      originalNotificationId,
      isResendToFailed: isFailed,
    });
    notify('安否確認を再送信しました', 'success');
  } catch (error) {
    switch (error.response.data.message) {
      case 'destination could not found':
        notify('削除済みのユーザーには安否確認を再送信できません', 'error');
        break;
      case 'phoneNumber is not found':
        setIsFailedSendModal(true);
        notify('安否確認の再送信に失敗しました', 'error');

        break;

      default:
        notify('安否確認の再送信に失敗しました', 'error');

        break;
    }
  } finally {
    formikHelpers.setSubmitting(false);
    handleCloseModal(false);
  }
};
